import { useEffect, useState } from "react";
import L from "leaflet";
import thermo from "./temp.png";

import {
  Chart as ChartJS,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Tooltip,
  Legend
} from "chart.js";

import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

ChartJS.register(
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Tooltip,
  Legend
);

export default function App() {

  const [devices, setDevices] = useState([]);
  const [history, setHistory] = useState([]);
  const [showChart, setShowChart] = useState(false);

  const icon = new L.Icon({
    iconUrl: thermo,
    iconSize:[42,42],
    iconAnchor:[21,42]
  });

  // ================= FETCH =================
  useEffect(()=>{

    fetch("http://38.7.145.166:3001/devices")
      .then(r=>r.json())
      .then(setDevices);

    fetch("http://38.7.145.166:3001/history")
      .then(r=>r.json())
      .then(setHistory);

    const socket = window.io?.("http://38.7.145.166:3001");

    if(socket){

      socket.on("deviceUpdate", data=>{
        setDevices(prev=>{
          const copy=[...prev];
          const i=copy.findIndex(d=>d.id===data.id);
          if(i>=0) copy[i]=data;
          else copy.push(data);
          return copy;
        });
      });

      socket.on("temp", msg=>{
        setHistory(prev=>[
          ...prev.slice(-200),
          {time:msg.time,value:msg.value}
        ]);
      });

    }

  },[]);

  if(devices.length===0){
    return <div style={{color:"#fff",padding:40}}>loading...</div>;
  }

  const latest = history.length
    ? history[history.length-1].value
    : null;

  // ================= CHART =================
  const chartData = {
    labels: history.map(r=>new Date(r.time)),
    datasets:[{
      data: history.map(r=>r.value),
      borderColor:"#00e5ff",
      backgroundColor:"rgba(0,229,255,0.15)",
      tension:0.3,
      pointRadius:0
    }]
  };

  const chartOptions={
    responsive:true,
    maintainAspectRatio:false,
    animation:false,
    plugins:{legend:{display:false}},
    scales:{
      x:{
        type:"time",
        ticks:{color:"#aaa"},
        grid:{color:"#222"}
      },
      y:{
        ticks:{color:"#aaa"},
        grid:{color:"#222"}
      }
    }
  };

  // ================= UI =================
  return (
    <div style={{
      height:"100vh",
      background:"#0b0b0b",
      color:"#fff",
      fontFamily:"system-ui"
    }}>

      {/* HEADER */}
      <div style={{
        position:"absolute",
        top:20,
        left:20,
        zIndex:999
      }}>

        <div style={{
          backdropFilter:"blur(12px)",
          background:"rgba(20,20,20,0.6)",
          padding:"12px 20px",
          borderRadius:12,
          boxShadow:"0 0 30px rgba(0,0,0,0.6)"
        }}>
          <div style={{fontSize:14,opacity:0.7}}>
            System temperature
          </div>
          <div style={{
            fontSize:34,
            color:"#00e5ff",
            fontWeight:"bold"
          }}>
            {latest?.toFixed(2)}°C
          </div>
        </div>

        {/* CHART BUTTON */}
        <button
          onClick={()=>setShowChart(!showChart)}
          style={{
            marginTop:12,
            padding:"10px 16px",
            borderRadius:10,
            border:"none",
            cursor:"pointer",
            background:"rgba(255,255,255,0.1)",
            color:"#fff",
            backdropFilter:"blur(10px)"
          }}
        >
          {showChart ? "Hide graph" : "Show graph"}
        </button>

      </div>

      {/* CHART PANEL */}
      {showChart && (
        <div style={{
          position:"absolute",
          top:20,
          right:20,
          width:420,
          height:220,
          zIndex:999,
          backdropFilter:"blur(14px)",
          background:"rgba(15,15,15,0.7)",
          borderRadius:14,
          padding:16,
          boxShadow:"0 0 40px rgba(0,0,0,0.6)"
        }}>
          <Line data={chartData} options={chartOptions}/>
        </div>
      )}

      {/* MAP */}
      <MapContainer
        center={[63.84426,23.13756]}
        zoom={13}
        style={{height:"100%",width:"100%"}}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>

        {devices.map(d=>(
          <Marker
            key={d.id}
            position={[d.lat,d.lng]}
            icon={icon}
          >
            <Popup>
              <div style={{
                backdropFilter:"blur(14px)",
                background:"rgba(10,10,10,0.7)",
                padding:14,
                borderRadius:12,
                color:"#fff",
                minWidth:160
              }}>
                <div style={{
                  fontSize:13,
                  opacity:0.6
                }}>
                  {d.type==="lake" ? "Hickarö resort vesi" : "Device"}
                </div>

                <div style={{
                  fontSize:18,
                  marginTop:6
                }}>
                  {d.name || d.id}
                </div>

                <div style={{
                  fontSize:28,
                  color:"#00e5ff",
                  marginTop:6
                }}>
                  {d.temp?.toFixed(2)}°C
                </div>

                {d.air && (
                  <div style={{opacity:0.7}}>
                    Ilma: {d.air}°C
                  </div>
                )}
              </div>
            </Popup>
          </Marker>
        ))}

      </MapContainer>

    </div>
  );
}
